/* eslint-disable */

/* tslint:disable */
import React from 'react';
export default (function (_a) {
  var style = _a.style;
  return React.createElement("svg", {
    className: "slideshow-arrow",
    style: style,
    width: "23",
    height: "39",
    viewBox: "0 0 23 39"
  }, React.createElement("path", {
    d: "M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z",
    transform: "translate(-855 -230)"
  }));
});
/* tslint:enable */

/* eslint-enable */